import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { UserPlus, LogIn, Clock, Shield, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface AuthGatePromptProps {
  message?: string;
}

export function AuthGatePrompt({ message = "Para solicitar atención necesitas una cuenta." }: AuthGatePromptProps) {
  const navigate = useNavigate();
  const returnTo = encodeURIComponent(window.location.pathname);

  const handleAuth = (mode: "register" | "login") => {
    navigate(`/auth?mode=${mode}&type=paciente&returnTo=${returnTo}`);
  };

  return (
    <div className="min-h-[60vh] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md"
      >
        <Card className="border-primary/20 shadow-lg">
          <CardContent className="pt-8 pb-8 px-6 text-center space-y-6">
            <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
              <UserPlus className="w-8 h-8 text-primary" />
            </div>

            <div className="space-y-2">
              <h2 className="text-xl font-bold text-foreground">
                {message}
              </h2>
              <p className="text-muted-foreground text-sm flex items-center justify-center gap-1.5">
                <Clock className="w-4 h-4" />
                Crear tu cuenta te tomará menos de 30 segundos.
              </p>
            </div>

            <div className="space-y-3">
              <Button
                onClick={() => handleAuth("register")}
                className="w-full gap-2"
                size="lg"
              >
                <UserPlus className="w-4 h-4" />
                Crear Cuenta Gratis
                <ArrowRight className="w-4 h-4" />
              </Button>

              <Button
                onClick={() => handleAuth("login")}
                variant="outline"
                className="w-full gap-2"
              >
                <LogIn className="w-4 h-4" />
                Ya tengo cuenta
              </Button>
            </div>

            <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
              <Shield className="w-3.5 h-3.5" />
              Tus datos están protegidos y seguros.
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
}
